import {Component, OnInit} from '@angular/core';
import {ParticipateService} from "../services/participate.service";
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-participate-response',
  templateUrl: './participate-response.component.html',
  styleUrls: ['./participate-response.component.styl']
})
export class ParticipateResponseComponent implements OnInit {

  payment = {
    total_value: 0,
    approved_date: '',
    via: 0,
    participant: {
      email: '',
      first_name: '',
      last_name: ''
    },
    purchase: {
      purchase_id: '',
      description: '',
      customer: {
        url: null
      },
      owner: {
        first_name: '',
        last_name: '',
      },
      response_url: null
    }
  };
  status = '';

  constructor(private route: ActivatedRoute,
              private router: Router,
              private participateService: ParticipateService) {
  }

  ngOnInit() {
    this.checkPaymentStatus();
  }

  backToCommerce() {
    document.location.href = this.payment.purchase.response_url ? this.payment.purchase.response_url : this.payment.purchase.customer.url;
  }

  private checkPaymentStatus() {
    this.route.queryParams.subscribe((params) => {
      this.participateService.getParticipationStatus(params.id_pago).subscribe((data: any) => {
        this.payment = data.payment;
        switch (data.payment.status) {
          case environment.states_payment.APPROVED:
            this.status = 'aprobado';
            break;
          case environment.states_payment.REJECTED:
          case environment.states_payment.REJECTED_CR:
            this.status = 'rechazado';
            break;
          case environment.states_payment.PENDING_BEGGINING:
          case environment.states_payment.PENDING_FINISH:
          case environment.states_payment.PENDING_FRAUD:
            this.status = 'pendiente';
            break;
          case environment.states_payment.TIMEOUT:
          case environment.states_payment.TIMEOUT_CODE_0:
            this.status = 'abandonado';
            break;
        }
      }, (err) => {
        this.router.navigate(['404']);
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/participate-response/participate-response.component.ts